// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { Entitlement, EntitlementsResponse, Trial, TrialSettings } from "../entitlements/dto.generated";
import type { Enforcement, Kind, LimitKey } from "../tiers/dto.generated";
export const addTagTypes = ["entitlements", "workspaces"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiEntitlementsTrial: build.query<
        GetApiEntitlementsTrialApiResponse,
        GetApiEntitlementsTrialApiArg
      >({
        query: () => ({ url: `/api/entitlements/trial` }),
        providesTags: ["entitlements"],
      }),
      getApiWorkspacesByIdEntitlements: build.query<
        GetApiWorkspacesByIdEntitlementsApiResponse,
        GetApiWorkspacesByIdEntitlementsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/entitlements`,
        }),
        providesTags: ["workspaces"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as entitlementsApi };
export type GetApiEntitlementsTrialApiResponse =
  /** status 200 OK */ { data: EntitlementsTrialSettings };
export type GetApiEntitlementsTrialApiArg = void;
export type GetApiWorkspacesByIdEntitlementsApiResponse =
  /** status 200 OK */ { data: EntitlementsEntitlementsResponse };
export type GetApiWorkspacesByIdEntitlementsApiArg = {
  /** Workspace ID */
  id: string;
};
export type EntitlementsTrialSettings = TrialSettings;
export type TiersEnforcement = Enforcement;
export type TiersLimitKey = LimitKey;
export type TiersKind = Kind;
export type EntitlementsEntitlement = Entitlement;
export type EntitlementsTrial = Trial;
export type EntitlementsEntitlementsResponse = EntitlementsResponse;
export const {
  useGetApiEntitlementsTrialQuery,
  useLazyGetApiEntitlementsTrialQuery,
  useGetApiWorkspacesByIdEntitlementsQuery,
  useLazyGetApiWorkspacesByIdEntitlementsQuery,
} = injectedRtkApi;
